<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const rows = ref([{}, {}, {}, {}, {}]);
</script>

<template>
    <DataTable :value="rows">
        <template #header>
            <div class="flex flex-wrap items-center justify-between">
                <span class="text-xl text-content font-bold">{{ t("pending.profiles.header") }}</span>
            </div>
        </template>
        <Column :header="t('pending.participants.firstname')">
            <template #body>
                <Skeleton></Skeleton>
            </template>
        </Column>
        <Column :header="t('pending.participants.lastname')">
            <template #body>
                <Skeleton></Skeleton>
            </template>
        </Column>
        <Column :header="t('pending.participants.email')">
            <template #body>
                <Skeleton></Skeleton>
            </template>
        </Column>
        <Column :header="t('pending.participants.product')">
            <template #body>
                <Skeleton></Skeleton>
            </template>
        </Column>
        <Column :header="t('pending.participants.status')">
            <template #body>
                <Skeleton></Skeleton>
            </template>
        </Column>
        <Column :header="t('pending.participants.actions')">
            <template #body>
                <Skeleton></Skeleton>
            </template>
        </Column>
    </DataTable>
</template>
